import { createFileRoute } from '@tanstack/react-router';
import { InscriptionGate } from '@/features/subscription/shared/InscriptionGate';
import InscriptionDuplicateProgramPage from '@/features/subscription/inscription-duplicate-program-page';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

/**
 * FAS-Inscrição RN-02 — tela explicativa "Você já tem inscrição neste
 * programa" exibida antes do formulário quando o candidato tenta se
 * inscrever em uma vaga cujo programa já tem outra inscrição ativa.
 *
 * Acessada via redirect do índice `$jobId_.inscricao.index.tsx` quando o
 * gate detecta duplicate; navegação direta pelo URL também funciona (a
 * página gerencia o estado de "checking" enquanto resolve as queries).
 */
export const Route = createFileRoute('/vagas/$jobId_/inscricao/programa-em-andamento')({
  component: () => (
    <InscriptionGate>
      <InscriptionDuplicateProgramPage />
    </InscriptionGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
